import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Biohazard"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-biohazard',
    templateUrl: './icon-biohazard.component.html',
    styleUrls: ['./icon-biohazard.component.scss'],
    standalone: false
})
export class IconBiohazardComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
